import { makeStyles } from '@mui/styles';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles({
  wrapper: {
    marginBottom: `${styles.spacing(6)}px`,
  },
  title: {
    marginBottom: `${styles.spacing(4)}px`,
    fontSize: 30,
    fontWeight: 300,
    textAlign: 'center',
  },
  list: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridGap: `${styles.spacing(3)}px`,
    [styles.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [styles.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  link: {
    padding: `${styles.spacing(2)}px`,
    borderRadius: 10,
    transition: styles.transitions.regular(['box-shadow']),
    textDecoration: 'none',
    '&:hover': {
      boxShadow: styles.shadows.regular,
    },
  },
  img: {
    display: 'block',
    margin: `0 auto ${styles.spacing(3)}px`,
  },
  name: {
    color: styles.palette.text.primary,
    textAlign: 'center',
    fontSize: '1.2rem',
    lineHeight: 1.4,
    fontWeight: 400,
  },
});
